import { EventEmitter, Injectable, TemplateRef } from '@angular/core';
import { AbstractDynamicComponent } from '@iupics-manager/models/abstract-dynamic-component';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceService {
  //#region linkedComponentToTabMap
  #linkedComponentToTabMap = new Map<string, AbstractDynamicComponent>();

  addLinkedComponentToTabMap(key: string, component: AbstractDynamicComponent): void {
    this.#linkedComponentToTabMap.set(key, component);
  }

  getLinkedComponentToTabMap(key: string): AbstractDynamicComponent {
    return this.#linkedComponentToTabMap.get(key);
  }

  removeLinkedComponentToTabMap(key: string): void {
    this.#linkedComponentToTabMap.delete(key);
  }
  //#endregion

  //#region ContextPanel
  showModalEmt = new EventEmitter<ModalData>();
  //#endregion

  //#region ContextPanel
  showContextPanelEmt = new EventEmitter<object>();
  //#endregion

  //#region openTargetSearch
  openTargetSearchEmt = new EventEmitter<object>();
  //#endregion
}

export type ModalData = {
  /** defines if the modal is displayed */
  display?: boolean;
  /** title of the modal */
  title: string;
  /** text content to use as the modal body. If body and templateRef are both presents, templateRef takes the priority. */
  body?: string;
  /** ngStyle applied to body. */
  bodyStyle?: object;
  /** templateRef to use as the modal body. If body and templateRef are both presents, templateRef takes the priority. */
  templateRef?: TemplateRef<unknown>;
  /** data used by templateRef */
  context?: object;
  /** number of milliseconds before the modal closed itself automatically. */
  timeout?: number;
  /** style of the modal. */
  modalStyle?: ModalStyle;
};

// todo: mettre ce type dans un fichier spécifique au modal car c'est le type utilisé par angularStyle dans ModalUiComponent
export type ModalStyle = {
  'iu-modal'?: object;
  'iu-modal-header'?: object;
  'iu-modal-body'?: object;
  'iu-modal-footer'?: object;
  'iu-modal-background'?: object;
};
